var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"popup",class:['c-popup', { active: _vm.currentlyActive === true }]},[_c('div',{staticClass:"c-popup__arrow",attrs:{"data-popper-arrow":""}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }